import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <nav className={styles.footerLinks}>
          <Link to="/impressum" className={styles.footerLink}>
            Impressum
          </Link>
          <Link to="/privacy" className={styles.footerLink}>
            Privacy Policy
          </Link>
          <Link to="/support" className={styles.footerLink}>
            Support
          </Link>
          <Link to="/terms" className={styles.footerLink}>
            Terms of Service
          </Link>
        </nav>
        <p className={styles.footerCopyright}>
          &copy; {currentYear} TOKO Math Club. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
